/**
 * Main header animation
 */

// Polyfill matches
/* eslint-disable max-len */
Element.prototype.matches = Element.prototype.matches
  || Element.prototype.mozMatchesSelector
  || Element.prototype.msMatchesSelector
  || Element.prototype.oMatchesSelector
  || Element.prototype.webkitMatchesSelector;
/* eslint-enable max-len */

DO.Subscribe(['app:ready'], () => {
  const header = document.querySelector('.header');
  const menu = document.querySelector('[data-menu]');
  const menuToggle = document.querySelector('[data-menu-toggle]');

  function toggleMenuAria(active) {
    menu.setAttribute('aria-hidden', active);
    menuToggle.setAttribute('aria-expanded', !active);
  }

  function getConfig() {
    return {
      classActive: 'header--open',
      classBody: 'body--fixed',
    };
  }

  function toggleBodyClasses(active) {
    document.body.classList[active ? 'remove' : 'add'](getConfig().classBody);
  }

  function closeMobileAccordions() {
    document.querySelectorAll('.menu-mobile [data-accordion] [aria-expanded="true"]').forEach((el) => {
      el.setAttribute('aria-expanded', 'false');
      el.closest('.accordion__item--active').classList.remove('accordion__item--active');
    });
  }

  function openFirstAccordion() {
    setTimeout(document.querySelector('.menu-mobile [data-accordion-trigger]').click(), 500);
  }

  function toggleHeader() {
    const active = header.classList.contains(getConfig().classActive);
    header.classList[active ? 'remove' : 'add'](getConfig().classActive);
    closeMobileAccordions();
    if (!active) openFirstAccordion();
    toggleMenuAria(active);
    toggleBodyClasses(active);
  }

  function handleHeaderClick(e) {
    if (
      !e.target.matches('[data-menu-toggle]')
      && header.classList.contains(getConfig().classActive)
    ) {
      toggleHeader();
    }
  }

  function attachEvents(scope) {
    menuToggle.addEventListener('click', toggleHeader);
    // header.addEventListener('click', handleHeaderClick);
    scope.addEventListener('keydown', (e) => {
      if (e.keyCode === 27) {
        // screw you IE
        header.classList.remove(getConfig().classActive);
      }
    });
  }

  function setup(scope) {
    attachEvents(scope);
  }

  function init() {
    setup(document);
  }

  init();
});
